window.MW = window.MW || {};
MW.modules = MW.modules || {};
MW.functions = MW.functions || {};
MW.elements = MW.elements || {};